// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * Custom product property controls for text and dropdown fields.
 */
class ProductCustomProperty extends Component {
  handleInput() {
    this.#updateCharacterCount();
  }

  handleSelectChange() {
    const { textInput, otherColorWrapper, otherColorInput } = this.refs;
    if (!otherColorWrapper || !otherColorInput) return;
    const isOther = textInput.value === 'Other';
    otherColorWrapper.hidden = !isOther;
    otherColorInput.disabled = !isOther;
    otherColorInput.required = isOther;
    if (!isOther) otherColorInput.value = '';
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    if (!characterCount || !textInput) return;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;
    const template = characterCount.getAttribute('data-template');
    if (!template) return;
    characterCount.textContent = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);
